import { ReactComponent as CircleTick } from '../../../assets/svg/circle_tick.svg';
import { ReactComponent as ErrorIcon } from '../../../assets/svg/triangle_error_icon.svg';
import './banner.scss';

const Banner = ({ banner, resetBanner }) => {
  const { show, message, isError, isWarning, disableTimeout } = banner;
  return (
    <div className="sticky-toaster dashboard-banner">
      {show ? (
        <div className="report-toaster report-toaster-pos">
          {disableTimeout ? (
            <div className="close-banner" onClick={resetBanner}>
              x
            </div>
          ) : null}
          {isError ? (
            <div className="icon-error">x</div>
          ) : isWarning ? (
            <ErrorIcon className="triangle-warning-icon" />
          ) : (
            <span>
              <CircleTick />
            </span>
          )}
          <div className="banner-message">{message}</div>
        </div>
      ) : null}
    </div>
  );
};

export default Banner;
